import { Sparkles, Check, ChevronUp } from 'lucide-react';

import { useTranslation } from 'react-i18next';
export function AIContentGenerationCard() {
    const { t } = useTranslation();
    return (
        <div className="bg-white dark:bg-gray-800 rounded-3xl border border-gray-200 dark:border-gray-700 p-4 sm:p-6 shadow-sm overflow-hidden min-h-[400px] flex flex-col transition-transform hover:-translate-y-1 hover:shadow-lg duration-300 relative group h-full">

            <div className="mb-6 relative z-10">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white leading-tight">{t('landing.mock.generateIdeas')}</h3>
            </div>

            {/* AI Generator Mockup Container */}
            <div className="flex-1 bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 flex flex-col overflow-hidden relative z-10 shadow-sm">

                {/* Mock Header */}
                <div className="p-3 border-b border-gray-100 dark:border-gray-800 flex items-center justify-between bg-white dark:bg-gray-950">
                    <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-lg bg-indigo-500 flex items-center justify-center shadow-sm">
                            <Sparkles className="w-3.5 h-3.5 text-white" />
                        </div>
                        <span className="text-xs font-bold text-indigo-600 dark:text-indigo-400 tracking-wide uppercase">{t('landing.mock.aiGenerator')}</span>
                    </div>
                    <div>
                        <ChevronUp className="w-4 h-4 text-gray-400" />
                    </div>
                </div>

                <div className="p-4 space-y-3 flex-1 flex flex-col bg-gray-50/30 dark:bg-gray-900/30">

                    {/* Prompt Input Mock */}
                    <div className="flex gap-2 mb-2">
                        <div className="flex-1 text-xs border border-gray-200 dark:border-gray-700 rounded-lg p-2.5 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 truncate shadow-sm">
                            Mackbook Hack for new users
                        </div>
                        <div className="px-3 rounded-lg text-xs font-bold text-white bg-gradient-to-r from-indigo-500 to-purple-500 border border-transparent flex items-center gap-1.5 shadow hover:opacity-90 transition-opacity cursor-pointer group/btn">
                            <Sparkles className="w-3.5 h-3.5 text-white" />{t('landing.mock.generate')}</div>
                    </div>

                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1 block">{t('landing.mock.pickResult')}</span>

                    {/* Result Card 1 */}
                    <div className="bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-800/50 rounded-xl p-3 shadow-sm transform transition-all hover:scale-[1.02] cursor-pointer relative overflow-hidden group/card shadow-indigo-100/50 dark:shadow-none ring-1 ring-indigo-500/10">
                        <div className="absolute top-3 right-3 w-5 h-5 rounded-md bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 flex items-center justify-center group-hover/card:border-indigo-300 group-hover/card:bg-indigo-50 transition-colors">
                            <Check className="w-3 h-3 text-gray-300 group-hover/card:text-indigo-400 opacity-0 group-hover/card:opacity-100 transition-opacity" />
                        </div>

                        <h4 className="text-xs font-bold text-gray-900 dark:text-white pr-6 mb-1">5 MacBook Hacks Every New User Must Know!</h4>
                        <p className="text-[10px] text-gray-500 dark:text-gray-400 leading-relaxed mb-2 pr-2">A quick reel showcasing 5 essential MacBook tips that will instantly boost productivity...</p>

                        <div className="flex flex-wrap gap-1.5 mb-2">
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-medium bg-purple-50 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400">#MacBookHacks</span>
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-medium bg-purple-50 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400">#TechTips</span>
                        </div>

                        <div className="flex items-center gap-1.5">
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-medium bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300">reel</span>
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-bold bg-green-50 text-green-600 dark:bg-green-900/20 dark:text-green-400 flex items-center gap-1">📈 high</span>
                        </div>
                    </div>

                    {/* Result Card 2 */}
                    <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700/50 rounded-xl p-3 shadow-sm transform transition-all hover:scale-[1.02] hover:border-indigo-200 cursor-pointer relative overflow-hidden group/card opacity-80 hover:opacity-100">
                        <div className="absolute top-3 right-3 w-5 h-5 rounded-md bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 flex items-center justify-center group-hover/card:border-indigo-300 group-hover/card:bg-indigo-50 transition-colors">
                            <Check className="w-3 h-3 text-gray-300 group-hover/card:text-indigo-400 opacity-0 group-hover/card:opacity-100 transition-opacity" />
                        </div>

                        <h4 className="text-xs font-bold text-gray-900 dark:text-white pr-6 mb-1">MacBook Trackpad Secrets You Didn't Know!</h4>
                        <p className="text-[10px] text-gray-500 dark:text-gray-400 leading-relaxed mb-2 pr-2">An engaging carousel post revealing hidden trackpad gestures and shortcuts...</p>

                        <div className="flex items-center gap-1.5 mt-2 pt-2 border-t border-gray-50 dark:border-gray-700/50">
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-medium bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300">carousel</span>
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-bold bg-green-50 text-green-600 dark:bg-green-900/20 dark:text-green-400 flex items-center gap-1">📈 medium</span>
                        </div>
                    </div>

                </div>
            </div>

            {/* Background decorative glow */}
            <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-indigo-500/5 dark:bg-indigo-500/10 blur-[50px] rounded-full pointer-events-none z-0"></div>
        </div>
    );
}
